import React from "react";
import { useTheme } from "@mui/material";
import { useGetTotalTalentQuery } from "../../services/report.service";
import DonutChartData from "../../components/global/DonutChartData";

interface DonutChartTalentProps {
  id?: string;
}

const DonutChartTalent: React.FC<DonutChartTalentProps> = ({ id }) => {
  const { data, isFetching, isLoading } = useGetTotalTalentQuery();
  const theme = useTheme();

  const dataMapper = React.useCallback(
    (data: any, theme: any) => [
      {
        name: "Active",
        value: data?.total_active || 0,
        color: theme.palette.primary.main,
      },
      {
        name: "Idle",
        value: data?.total_idle || 0,
        color: theme.palette.secondary.main,
      },
    ],
    []
  );

  return (
    <DonutChartData
      id={id}
      data={data}
      isLoading={isLoading}
      isFetching={isFetching}
      dataMapper={dataMapper}
    />
  );
};

export default DonutChartTalent;
